import React from 'react';

import useDataConfig from 'b2b-ui-components-lib/lib/hooks/useDataConfig';
import PostLoginFooter from 'b2b-ui-components-lib/lib/components/postLoginFooter';
import ABFooter from 'b2b-ui-components-lib/lib/components/ABfooter';
import { isEDLJourney } from 'common/utils/app.utils';

const AppFooter = (props) => {
  const { isAuthJourney } = props;

  if (isAuthJourney === null) return null;

  const { config } = useDataConfig();

  if (isEDLJourney()) {
    return null;
  }

  return <React.Fragment>{isAuthJourney ? <PostLoginFooter config={config} /> : <ABFooter flowName="dedicated internet" />}</React.Fragment>;
};

export default AppFooter;
